import { animated, easings, useSpring } from "react-spring";
import { Flex, Paper, Skeleton, Text } from "@mantine/core";

export interface OverviewStatCardProps {
    title: string;
    subTitle: string;
    value: number;
    subComponent?: any;
    minWidth?: number;
}

export const StatisticCard = ({ subTitle, subComponent, title, value, minWidth = 200 }: OverviewStatCardProps) => {
    const { number } = useSpring({
        from: { number: 0 },
        to: { number: value },
        config: {
            duration: 1000,
            mass: 1,
            tension: 20,
            friction: 10,
            easing: easings.easeOutQuart,
        }, // Animation duration in milliseconds
    });

    const isDecimal = !!value.toString().includes(".");

    return (
        <Paper px={32} pt={28} pb={24} style={{ borderRadius: 12, flex: `1 1 ${minWidth}px` }}>
            <Text fw="bold">{title}</Text>
            <Text color="#888E98">{subTitle}</Text>
            <Flex gap={20} align="flex-end" mt={14}>
                <Text size={40} fw={500} style={{ lineHeight: 1.3 }}>
                    <animated.span>{number.to((n) => n.toFixed(isDecimal ? 1 : 0))}</animated.span>
                </Text>
                {subComponent}
            </Flex>
        </Paper>
    );
};
